import { render, staticRenderFns } from "./ConfigCharacter.vue?vue&type=template&id=dfef6534&scoped=true&"
import script from "./ConfigCharacter.vue?vue&type=script&lang=js&"
export * from "./ConfigCharacter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfef6534",
  null
  
)

export default component.exports